import { useState } from "react";
import useMerchantPortalAxios, { useMerchantPortalFormData } from "../utils/axios";
import { useDispatch } from "react-redux";
import { setCompanyTransferData } from "../features/BOBCorporateSlice";


const usePayCorporationApi = () => {

    const [companyCategories, setCompanyCategories] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [totalNbOfPage, setTotalNbOfPage] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [companyTransfers, setCompanyTransfers] = useState([]);

    const [loading, setLoading] = useState(false);

    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();

    const dispatch = useDispatch();


    const GetCompanyTransfers = async (pageNb, dateFrom, dateTo) => {
        setLoading(true)
        await MerchantPortalAxios.post("/v1/PayCorporation/GetCompanyTransfers", {
            SessionID: sessionStorage.getItem("SessionID"),
            page: pageNb,
            pageSize: 10,
            DateFrom: dateFrom,
            DateTo: dateTo
        }).then((res) => {
            const transfers = res.data.Payload.CompanyTransfers;
            setCompanyTransfers(transfers);
    
            if (transfers.length === 0) {
                setTotalCount(0);
                setTotalNbOfPage(0);
            } else {
                setTotalNbOfPage(transfers[0].TotalPages || 0);
                setTotalCount(transfers[0].TotalCount || 0);
            }
        })
        .finally(() => {
            setLoading(false);
        });
    };


    const GetCompanyCategories = async () => {
        try {
            const res = await MerchantPortalAxios.post(
                '/v1/PayCorporation/GetCompanyCategories',
                {
                    SessionID: sessionStorage.getItem("SessionID"),
                }
            )
            setCompanyCategories(res.data.Payload.CompanyCategories)

            return res;
        } catch (error) {
            console.error(error);
        }
    }

    const GetTansferCompanies = async () => {
        try {
            const res = await MerchantPortalAxios.post(
                '/v1/PayCorporation/GetTansferCompanies',
                {
                    SessionID: sessionStorage.getItem("SessionID"),
                }
            )

            setCompanies(res.data.Payload.Companies);

            return res;
        } catch (error) {
            console.error(error);
        }
    }

    const SimulateCompanyTransfer = async (currencyID, amount, companyID) => {
        try {
            const res = await MerchantPortalAxios.post(
                "/v1/PayCorporation/SimulateCompanyTransfer",
                {
                    SessionID: sessionStorage.getItem("SessionID"),
                    CurrencyID: currencyID,
                    Amount: amount,
                    CompanyID: companyID
                }
            )

            dispatch(setCompanyTransferData(res.data.Payload))

            return res;
        } catch (error) {
            console.error(error);
        }
    }

    const ExecuteCompanyTransfer = async (formData) => {
       
        const response = await MerchantPortalAxios1.post(
            "/v1/PayCorporation/ExecuteCompanyTransfer",
            formData
        );

        return response.data.Payload;
    };
    

    return {
        GetCompanyCategories,
        companyCategories,
        GetTansferCompanies,
        companies,
        SimulateCompanyTransfer,            
        GetCompanyTransfers,
        totalCount,
        totalNbOfPage,
        companyTransfers,
        loading,
        ExecuteCompanyTransfer
    }

}

export default usePayCorporationApi;